// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import { Injectable } from '@angular/core';
import { getGantryInitStatus } from '../../../api/remote-api/.ctsystemstatus.generated/fn/ct-system-status/get-gantry-init-status';
import { getGantryStartupLogs } from '../../../api/remote-api/.ctsystemstatus.generated/fn/ct-system-status/get-gantry-startup-logs';
import { getGantryEventList } from '../../../api/remote-api/.ctsystemstatus.generated/fn/ct-system-status/get-gantry-event-list';
import { getGantryWorkflow } from '../../../api/remote-api/.ctsystemstatus.generated/fn/ct-system-status/get-gantry-workflow';
import { MapApiService } from '../../shared/services/map-api.service';

@Injectable({
  providedIn: 'root',
})
export class CtstatusService {
  public constructor(private readonly mapApiService: MapApiService) {}

  public gantryEventListInitStatus = this.mapApiService.mapEndpoint(
    getGantryInitStatus,
    {
      customCacheKey: (params) => JSON.stringify(params),
    },
  );
  public gantryEventLogs = this.mapApiService.mapEndpoint(getGantryStartupLogs);
  public gantryEvents = this.mapApiService.mapEndpoint(getGantryEventList, {
    customCacheKey: (params) => JSON.stringify(params),
  });

  public gantryworkflow1st = this.mapApiService.mapEndpoint(getGantryWorkflow, {
    customCacheKey: (params) => JSON.stringify(params),
  });
  public gantryworkflow2nd = this.mapApiService.mapEndpoint(getGantryWorkflow, {
    customCacheKey: (params) => JSON.stringify(params),
  });
  public gantryworkflowDetail = this.mapApiService.mapEndpoint(
    getGantryWorkflow,
    {
      customCacheKey: (params) => JSON.stringify(params),
    },
  );
}
